"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stickyAnimation = exports.sticky = exports.propTheme = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var propTheme = function propTheme(path, defaultThemeValue) {
  return function (props) {
    var value = props[path];
    var result = props.theme[value];

    if (!value) {
      return props.theme[defaultThemeValue];
    }

    if (result) {
      return result;
    }

    return value;
  };
};

exports.propTheme = propTheme;

var sticky = function sticky(_ref) {
  var fixed = _ref.fixed,
      theme = _ref.theme;
  return fixed && (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n\n    // fix iOS menu flicker\n    &::after {\n      content: '';\n      background-color: ", ";\n      width: 100%;\n      height: 50vh;\n      position: fixed;\n      bottom: -50vh;\n      z-index: 0;\n      pointer-events: none;\n\n      ", "\n    }\n  "])), _styleUtilities.palette.backgroundWhite(theme), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        display: none;\n      "]))));
};

exports.sticky = sticky;

var stickyAnimation = function stickyAnimation(_ref2) {
  var fixed = _ref2.fixed;
  return fixed && (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    animation: fixing 0.2s forwards;\n\n    @keyframes fixing {\n      from {\n        transform: translate3d(0, -100%, 0) rotate(0.002deg);\n      }\n\n      to {\n        transform: translate3d(0, 0, 0) rotate(0.002deg);\n      }\n    }\n  "])));
};

exports.stickyAnimation = stickyAnimation;